




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AdbSwitch',
})
export default class extends Vue {}
